import { create } from "zustand";
import type { TradeResponse } from "../types/trades";

interface TradesState {
  trades: Map<string, TradeResponse>;
  setSnapshot: (rows: TradeResponse[]) => void;
  applyDelta: (upserts: TradeResponse[], removedIds: string[]) => void;
  clear: () => void;
}

export const useTradesStore = create<TradesState>((set, get) => ({
  trades: new Map(),
  setSnapshot: (rows) => {
    const m = new Map<string, TradeResponse>();
    for (const r of rows) m.set(r.trade_id, r);
    set({ trades: m });
  },
  applyDelta: (upserts, removedIds) => {
    const next = new Map(get().trades);
    for (const id of removedIds) next.delete(id);
    for (const r of upserts) next.set(r.trade_id, r);
    set({ trades: next });
  },
  clear: () => set({ trades: new Map() }),
}));

export function selectTradesArray(state: TradesState): TradeResponse[] {
  return Array.from(state.trades.values());
}
